import { storyBlock } from "@/pages/home/data";

export default function StoryFeature() {
  return (
    <section id="story" className="scroll-anchor bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-start gap-10 lg:grid-cols-12">
          {/* 特稿图片 */}
          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-xl">
              <img src={storyBlock.image} alt={storyBlock.alt} className="aspect-[4/5] w-full object-cover" />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/95 px-3 py-1 text-xs font-bold text-primary-600">
                <i className="ri-article-line" aria-hidden="true"></i>
                {storyBlock.eyebrow}
              </span>
            </div>
          </div>

          {/* 特稿正文 */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 text-sm font-bold text-primary-600">
              <span className="h-px w-8 bg-primary-500"></span>
              {storyBlock.eyebrow}
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
              {storyBlock.title}
            </h2>
            <p className="mt-5 font-heading text-lg font-semibold leading-relaxed text-foreground-800 md:text-xl">
              {storyBlock.lead}
            </p>

            <div className="mt-5 space-y-4 text-[15px] leading-7 text-foreground-700">
              {storyBlock.body.map((p, i) => (
                <p key={i} className="first-letter:float-left first-letter:mr-1.5 first-letter:font-heading first-letter:text-4xl first-letter:font-black first-letter:leading-none first-letter:text-primary-500">
                  {p}
                </p>
              ))}
            </div>

            <blockquote className="mt-6 border-l-4 border-accent-500 bg-accent-50 py-3 pl-5 pr-4 font-heading text-lg font-bold leading-relaxed text-accent-800">
              {storyBlock.pullquote}
            </blockquote>

            <div className="mt-7 flex flex-wrap items-center gap-3 text-sm">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 font-medium text-secondary-800">
                <i className="ri-question-line" aria-hidden="true"></i>
                来源是谁？
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 font-medium text-secondary-800">
                <i className="ri-file-search-line" aria-hidden="true"></i>
                证据在哪？
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 font-medium text-secondary-800">
                <i className="ri-error-warning-line" aria-hidden="true"></i>
                还缺了什么？
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}